import { useEffect, useState } from "react";
import { Card, Select, Row, Col, Form, Spin, Empty } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import "./FancySlips.scss";
import {
  useGetSessionBetMutation,
  useGetSessionHavingBetQuery,
} from "../../../../store/service/SportDetailServices";
import { useLazyFilterbyClientQuery } from "../../../../store/service/supermasteAccountStatementServices";

const FancyBets = () => {
  const [clientId, setClientId] = useState("");
  const [oddsType, setOddsType] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const nav = useNavigate();
  const { id, inplay } = useParams();

  const { data: sessionBets } = useGetSessionHavingBetQuery({
    matchCompleted: inplay !== "1" ? true : false,
    matchId: id ?? "",
  });
  const [trigger, { data: sessionData }] = useGetSessionBetMutation();
  const [userTrigger, { data: userData }] = useLazyFilterbyClientQuery();

  useEffect(() => {
    userTrigger({ userId: "", userType: 1 });
  }, []);

  useEffect(() => {
    trigger({
      matchId: id,
      userId: clientId,
      marketId: oddsType,
      matchCompleted: inplay !== "1" ? true : false,
    });
  }, [oddsType, clientId, id, inplay]);

  const handleBackClick = () => {
    nav(-1);
  };

  const onFinish = () => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  return (
    <>
      <div className="match_slip ledger_data led_super">
        <Card
          style={{ margin: "0px", width: "100%" }}
          className="sport_detail session_bet"
          title="Fancy Bets"
          extra={<button onClick={handleBackClick}>Back</button>}>
          <Form
            name="basic"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            className="form_data">
            <Row className=" fancy_data_sess mr">
              <Col xs={24} md={24} lg={8} xl={8}>
                <Form.Item
                  name="username"
                  label=""
                  required={false}
                  rules={[{ required: true, message: "Please Select User" }]}>
                  <Select
                    placeholder="Select User"
                    showSearch
                    onSearch={(value) => {
                      if (value) userTrigger({ userId: value, userType: 1 });
                    }}
                    value={clientId}
                    allowClear
                    onSelect={(value) => setClientId(value)}
                    options={
                      userData?.data?.map((user) => ({
                        label: `${user.userName} (${user.userId})`,
                        value: user.userId,
                      })) || []
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={24} lg={8} xl={8}>
                <Form.Item name="" label="" required={false}>
                  <Select
                    placeholder="Select Fancy"
                    value={oddsType}
                    options={[
                      { value: "", label: "All Fancies" },
                      ...(sessionBets?.data || []).map((item) => ({
                        value: item.fancyId,
                        label: item.fancyName,
                      })),
                    ]}
                    showSearch
                    allowClear
                    onSelect={(value) => setOddsType(value)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>

          {isLoading ? (
            <Spin className="loading_active" tip="Loading..." size="large">
              <div className="content" />
            </Spin>
          ) : (
            <div className="table_section statement_tabs_data active_match_table">
              <table className="">
                <thead>
                  <tr>
                    <th>Client Name</th>
                    <th>Run</th>
                    <th>Rate</th>
                    <th>Amount</th>
                    <th>Type</th>
                    <th>Session</th>
                    <th>Creator Name</th>
                    <th>Date</th>
                    <th>Loss</th>
                    <th>Profit</th>
                  </tr>
                </thead>
                <tbody>
                  {sessionData?.data?.length > 0 ? (
                    sessionData?.data?.map((res, id) => (
                      <tr
                        key={id}
                        className={res?.mode === "YES" ? "back" : "lay"}>
                        <td>
                          {res?.parentName} ({res?.parentId})
                        </td>
                        <td>{res?.run}</td>
                        <td>{res?.rate}</td>
                        <td>{res?.amount}</td>
                        <td>{res?.mode}</td>
                        <td>{res?.selectionName}</td>
                        <td>
                          {res?.username} ({res?.userId})
                        </td>

                        <td>{res?.time}</td>
                        <td>{res?.liability}</td>
                        <td>{res?.pnl}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={10}>
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </Card>
      </div>
    </>
  );
};

export default FancyBets;
